// @ts-strict-ignore
import flatten from 'flat'
import { useFormikContext } from 'formik'
import { FC, useEffect, useRef } from 'react'

export const ScrollToFormError: FC = () => {
  const { errors, values: formikValues, isSubmitting, isValidating } = useFormikContext()
  const timer = useRef<NodeJS.Timeout>()

  //
  // All input fields have the attribute "data-field-id" that corresponds to the field names in the formik schema.
  // The values and errors objects are not necessarily in the same order as the fields in the DOM,
  // We need to find the highest field in the DOM that has an error and scroll to that field.
  //
  useEffect(() => {
    if (isSubmitting && !isValidating) {
      let formikFieldKeysWithErrors = flatten(errors)
      let formikFieldKeys = Object.keys(flatten(formikValues))

      const allInputFields = document.querySelectorAll('[data-field-id]')
      let fieldKeysInDomOrder: string[] = []

      allInputFields.forEach((element) => {
        const fieldId = element.getAttribute('data-field-id')
        if (fieldId && formikFieldKeys.includes(fieldId)) {
          fieldKeysInDomOrder.push(fieldId)
        }
      })

      let firstErroredElement = fieldKeysInDomOrder.find((key) => formikFieldKeysWithErrors[key])

      if (firstErroredElement) {
        let element = document.getElementsByName(firstErroredElement)[0]

        //
        // By default the input element itself is not displayed in the viewport,
        // so we need to scroll its label, which is always its next sibling
        //
        const isCheckbox = element.getAttribute('type') === 'checkbox'
        if (isCheckbox) {
          element = element.nextSibling as HTMLElement
        }

        if (element && typeof element.getBoundingClientRect === 'function') {
          const top = element.getBoundingClientRect().top + document.documentElement.scrollTop - 150
          window.scrollTo({
            top,
            left: 0,
            behavior: 'smooth',
          })

          clearTimeout(timer.current)
          timer.current = setTimeout(() => {
            element.focus()
          }, 500)
        }
      }
    }
  }, [errors, isSubmitting, isValidating]) // eslint-disable-line

  return null
}
